import React, { useState, useEffect } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import { Howl } from 'howler'

import icPlay from '../assets/images/ic-play.svg'
import icStop from '../assets/images/ic-stop.svg'
import icLucidText from '../assets/images/ic-lucid-text.png'

import { analytics } from '../config/firebase'
import client from '../module/client'
import Loading from '../components/Loading';

function Share() {
  analytics.logEvent('page_view', {
    page_title: 'Share'
  })

  const location = useLocation()
  const history = useHistory()
  const mbti = (new URLSearchParams(location.search).get('innerself')).toLowerCase()
  
  const [loaded, setLoaded] = useState(false)
  const [modifier, setModifier] = useState('')
  const [name, setName] = useState('')
  const [description, setDescription] = useState('')
  const [audioName, setAudioName] = useState('')
  const [audioFile, setAudioFile] = useState('')
  const [friendName, setFriendName] = useState('')
  const [friendMbti, setFriendMbti] = useState('')
  const [isPlaying, setIsPlaying] = useState(false)
  const [sound, setSound] = useState('')
  
  useEffect(() => {
    client({
      method: 'get',
      url: '/result',
      params: {
        mbti: mbti
      }
    }).then(res => {
      setModifier(res.data.modifier)
      setName(res.data.name)
      setDescription(res.data.description)
      setAudioName(res.data.audioName)
      setAudioFile(res.data.audioFile)
      setFriendName(res.data.friendName)
      setFriendMbti(res.data.friendMbti)
      setLoaded(true)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const playSound = (src) => {
    const sound = new Howl({
      src,
      html5: true
    })
    setSound(sound)
    sound.play();
  }
  
  const togglePlay = () => {
    if (isPlaying) {
      sound.stop()
      setIsPlaying(false)
    } else {
      playSound(audioFile)
      setIsPlaying(true)
    }
  }

  const goToStart = () => {
    history.push("/")
  }

  const playIcon = isPlaying ? (
    <img src={icStop} className="ic-stop" alt="stop" />
  ) : (
    <img src={icPlay} className="ic-play" alt="play" />
  )

  return loaded ? (
    <div className={`result-wrapper ${mbti}`}>
      <div className="lucid-text-logo">
        <img src={icLucidText} alt="lucid" />
      </div>
      <div className="character-wrapper"></div>
      <div className="result-description-wrapper">
        <div className="modifier">{modifier}</div>
        <div className="name">{name}</div>
        <div className="description">{description}</div>
      </div>
      <div className="soulsound-wrapper">
        <div className="title">#용왕님 추천 오디오</div>
        <div className="sound-item" onClick={togglePlay}>
          <div className="sound-name">{audioName}</div>
          <div className="play-icon">
            {playIcon}
          </div>
        </div>
      </div>
      <div className="friend-wrapper">
        <div className="title">#나와의 찰떡궁합</div>
        <div className={`friend-img ${friendMbti}`}></div>
        <div className="friend-name">{friendName}</div>
      </div>
      <div className="last-gift" onClick={goToStart}>나도 테스트 하러가기 🙌</div>
    </div>
  ) : <Loading />
}

export default Share